import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  tabindex: "-1",
  role: "dialog",
  ref: "modalConfirm",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  key: 0,
  class: "modal-header"
}
const _hoisted_5 = { class: "modal-title" }
const _hoisted_6 = { class: "modal-body p-3" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (!!_ctx.notification.title)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.notification.title), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h3", null, [
            _createElementVNode("b", {
              innerHTML: _ctx.notification.message
            }, null, 8, _hoisted_7)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClick(false)))
          }, _toDisplayString(_ctx.notification.cancelButton), 1),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-danger",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClick(true)))
          }, _toDisplayString(_ctx.notification.acceptButton), 1)
        ])
      ])
    ])
  ], 512))
}